import { useInfiniteQuery } from '@tanstack/react-query'
import { listAlerts, type ListArgs } from '../api'
import type { AlertsListResponse } from '../types'

export const alertsInfiniteQueryKey = (args: Omit<ListArgs, 'page' | 'pageSize'>) =>
  ['alerts', 'list-infinite', args] as const

const PAGE_SIZE = 50

export function useAlertsInfinite(args: Omit<ListArgs, 'page' | 'pageSize'>) {
  return useInfiniteQuery<AlertsListResponse>({
    queryKey: alertsInfiniteQueryKey(args),
    queryFn: ({ pageParam }) =>
      listAlerts({ ...args, page: pageParam as number, pageSize: PAGE_SIZE }),
    initialPageParam: 1,
    getNextPageParam: (last, all) => {
      const loaded = all.reduce((sum, p) => sum + p.alerts.length, 0)
      return loaded < last.total ? all.length + 1 : undefined
    },
    staleTime: 5_000,
  })
}
